// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aN532","skillsSideMenu":"styles_skillsSideMenu__1dJvo"};